export enum CompanyCategoryEnum {
    OWN = "Own",
    OTHER = "Other",
}